// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"88c8801e","977":"097bfc70"}[chunkId] + ".chunk.js";
};